import React, {  memo, Fragment } from 'react';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import UpperHalf from './components/UpperHalf';
import NavbatController from './components/NavbarController';
import Footer from './components/Footer';
import More from './components/More';
import { people, moreData, dataForTakeaway, dataForResult } from './editor/text';
import { sectionIds } from './config';
import Carousel from './components/Carousel';
import { verticalSpace, horizontalPadding } from './components/DisplayComponents';
import { setup, stage } from './config';
import ScrollToTop from './components/ScrollToTop';

const { currentStage } = setup;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
`;

const SapceWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  padding: 0 ${horizontalPadding};
  margin: 16px auto;
  box-sizing: border-box;
`;

const theme = {
  backgroundColor: '#E5E5E5',
  blue: '#1C3077',
  disableGray: '#A8A8A8',
  fontFamily: '"Noto Sans TC", sans-serif',
  color: '#373737',
  agreeYellow: '#FFB800',
  disagreeRed: '#E9310B',
  borderGray: '#C4C4C4',
};

const Border = styled.div`
  margin: 32px auto;
  border: 1px solid ${props => props.theme.borderGray};
  width: 90%;
`;

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background-color: ${props => props.theme.backgroundColor};
    font-family: ${props => props.theme.fontFamily};
    color: ${props => props.theme.color};
  }

  h2 {
    font-size: 22px;
    font-weight: bold;
    margin: 0;
  }

  h3 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
  }

  h4 {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
  }

  blockquote.twitter-tweet {
    display: inline-block;
    font-family: "Helvetica Neue", Roboto, "Segoe UI", Calibri, sans-serif;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
    border-color: #eee #ddd #bbb;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    margin: 10px 5px;
    padding: 0 16px 16px 16px;
    max-width: 468px;
  }

  blockquote.twitter-tweet p {
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
  }

  blockquote.twitter-tweet a {
    color: inherit;
    font-weight: normal;
    text-decoration: none;
    outline: 0 none;
  }

  blockquote.twitter-tweet a:hover,
  blockquote.twitter-tweet a:focus {
    text-decoration: underline;
  }

  p {
    line-height: 160%;
  }
`;

function App({
  location,
  history,
}) {
  const Graphic = (() => {
    if (currentStage !== stage.history) {
      return null;
    }
    return (
      <Fragment>
        <a id={sectionIds.graphic} />
        <SapceWrapper>
          <h2>
            開票結果
          </h2>
        </SapceWrapper>
        <Carousel
          textFirst
          data={dataForResult}
        />
        <Border />
      </Fragment>
    );
  })();

  return (
    <Fragment>
      <ThemeProvider
        theme={theme}
      >
        <NavbatController />
        <Container>
          <UpperHalf
            location={location}
            history={history}
          />
          <Border />
          <a id={sectionIds.takeAway} />
          <SapceWrapper>
            <h2>
              罷免懶人包
            </h2>
          </SapceWrapper>
          <Carousel
            data={dataForTakeaway}
          />
          <Border />
          {Graphic}
          <a id={sectionIds.more} />
          <More
            data={moreData}
            title="延伸閱讀"
          />
        </Container>
        <Footer
          people={people}
        />
        <GlobalStyle />
        <ScrollToTop />
      </ThemeProvider>
    </Fragment>
  );
}

export default memo(App);
